import React, { useEffect, useState } from 'react';
import ReportDataTable from '../../components/reports/ReportDataTable';
import ReportsSidebar from '../../components/reports/ReportsSidebar';
import reportsApi from '../../services/api/reportsApi';
import './Reports.css';

const Reports = () => {
  const [reports, setReports] = useState([]);
  const [selectedReportId, setSelectedReportId] = useState(null);
  const [reportData, setReportData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Carregar lista de relatórios ao montar o componente
  useEffect(() => {
    loadReports();
  }, []);

  const loadReports = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await reportsApi.listReports();
      setReports(response.items || []);
    } catch (error) {
      console.error('Erro ao carregar relatórios:', error);
      setError('Erro ao carregar lista de relatórios');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectReport = async (report) => {
    if (selectedReportId === report.id) {
      return; // Já está selecionado
    }

    setSelectedReportId(report.id);
    setReportData(null);
    setError(null);

    try {
      setIsLoading(true);
      const data = await reportsApi.executeReport(report.id);
      setReportData(data);
    } catch (error) {
      console.error('Erro ao executar relatório:', error);
      setError(`Erro ao executar relatório: ${error.message || 'Erro desconhecido'}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRetry = () => {
    if (selectedReportId) {
      const report = reports.find(r => r.id === selectedReportId);
      if (report) {
        handleSelectReport(report);
      }
    }
  };

  return (
    <div className="reports-page">
      {/* Sidebar com lista de relatórios */}
      <ReportsSidebar
        reports={reports}
        selectedReportId={selectedReportId}
        onSelectReport={handleSelectReport}
      />

      {/* Área principal de conteúdo */}
      <div className="reports-main-content">
        {isLoading && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
            <p>Carregando relatório...</p>
          </div>
        )}

        {error && (
          <div className="error-state">
            <div className="error-icon">⚠️</div>
            <h3>Erro</h3>
            <p>{error}</p>
            <button 
              className="btn btn-primary"
              onClick={handleRetry}
            >
              Tentar Novamente
            </button>
          </div>
        )}

        {!isLoading && !error && (
          <ReportDataTable reportData={reportData} />
        )}
      </div>
    </div>
  );
};

export default Reports;
